
import { defineComponent } from "vue";
import DPlayer from "@/components/DPlayer.vue";

export default defineComponent({
  components: {
    DPlayer
  }
});
